'use strict';

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _AwaitValue(value) { this.wrapped = value; }

function _asyncGeneratorDelegate(inner, awaitWrap) { var iter = {}, waiting = false; function pump(key, value) { waiting = true; value = new Promise(function (resolve) { resolve(inner[key](value)); }); return { done: false, value: awaitWrap(value) }; } ; if (typeof Symbol === "function" && Symbol.iterator) { iter[Symbol.iterator] = function () { return this; }; } iter.next = function (value) { if (waiting) { waiting = false; return value; } return pump("next", value); }; if (typeof inner.throw === "function") { iter.throw = function (value) { if (waiting) { waiting = false; throw value; } return pump("throw", value); }; } if (typeof inner.return === "function") { iter.return = function (value) { if (waiting) { waiting = false; return value; } return pump("return", value); }; } return iter; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

const normaliseInput = require('ipfs-core-utils/src/files/normalise-input');

const toStream = require('./to-stream');

const {
  nanoid
} = require('nanoid');

const modeToString = require('../lib/mode-to-string');

const mtimeToObject = require('../lib/mtime-to-object');

const merge = require('merge-options').bind({
  ignoreUndefined: true
});

async function multipartRequest(source = '', abortController, headers = {}, boundary = "-----------------------------".concat(nanoid())) {
  function streamFiles(_x) {
    return _streamFiles.apply(this, arguments);
  }

  function _streamFiles() {
    _streamFiles = _wrapAsyncGenerator(function* (source) {
      try {
        let index = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;

        var _iteratorError;

        try {
          for (var _iterator = _asyncIterator(normaliseInput(source)), _step, _value; _step = yield _awaitAsyncGenerator(_iterator.next()), _iteratorNormalCompletion = _step.done, _value = yield _awaitAsyncGenerator(_step.value), !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
            const {
              content,
              path,
              mode,
              mtime
            } = _value;
            let fileSuffix = '';
            const type = content ? 'file' : 'dir';

            if (index > 0) {
              yield '\r\n';
              fileSuffix = "-".concat(index);
            }

            yield "--".concat(boundary, "\r\n");
            yield "Content-Disposition: form-data; name=\"".concat(type).concat(fileSuffix, "\"; filename=\"").concat(encodeURIComponent(path), "\"\r\n");
            yield "Content-Type: ".concat(content ? 'application/octet-stream' : 'application/x-directory', "\r\n");

            if (mode !== null && mode !== undefined) {
              yield "mode: ".concat(modeToString(mode), "\r\n");
            }

            if (mtime != null) {
              const {
                secs,
                nsecs
              } = mtimeToObject(mtime);
              yield "mtime: ".concat(secs, "\r\n");

              if (nsecs != null) {
                yield "mtime-nsecs: ".concat(nsecs, "\r\n");
              }
            }

            yield '\r\n';

            if (content) {
              yield* _asyncGeneratorDelegate(_asyncIterator(content), _awaitAsyncGenerator);
            }

            index++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              yield _awaitAsyncGenerator(_iterator.return());
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (err) {
        // workaround for https://github.com/node-fetch/node-fetch/issues/753
        abortController.abort(err);
      } finally {
        yield "\r\n--".concat(boundary, "--\r\n");
      }
    });
    return _streamFiles.apply(this, arguments);
  }

  return {
    headers: merge(headers, {
      'Content-Type': "multipart/form-data; boundary=".concat(boundary)
    }),
    body: await toStream(streamFiles(source))
  };
}

module.exports = multipartRequest;